var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_DISCOUNT_CODES = 'api/v2/discountCodes';
const GET_SET_AUTOMATIC_DISCOUNTS = 'api/discounts';
export const deleteDiscountCodeById = function (storeId, discountId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.delete(`${GET_SET_DISCOUNT_CODES}/${storeId}/${discountId}`, config);
        }
        catch (error) {
            console.error('Error fetching deleteDiscountCodeById:', error);
            throw error;
        }
    });
};
export const deleteAutomaticDiscountById = function (storeId, discountId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.delete(`${GET_SET_AUTOMATIC_DISCOUNTS}/${storeId}/${discountId}`, config);
        }
        catch (error) {
            console.error('Error fetching deleteAutomaticDiscountById:', error);
            throw error;
        }
    });
};
export const updateAutomaticDiscountById = function (storeId, discountId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_SET_AUTOMATIC_DISCOUNTS}/${storeId}/${discountId}`, data, config);
        }
        catch (error) {
            console.error('Error fetching updateById:', error);
            throw error;
        }
    });
};
export const updateDiscountCodeById = function (storeId, discountId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_SET_DISCOUNT_CODES}/${storeId}/${discountId}`, data, config);
        }
        catch (error) {
            console.error('Error fetching updateDiscountCodeById:', error);
            throw error;
        }
    });
};
